import React, { createContext, useReducer } from 'react'

import subCategoryReducer from './SubCategoryReducer'

const initialState = { subcategories: false, loading: true }

export const SubCategoryContext = createContext(initialState)

export const SubCategoryContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(subCategoryReducer, initialState)

  function getAllSubCategories(subcategories) {
    dispatch({
      type: 'GET_ALL_SUBCATEGORIES',
      payload: subcategories,
    })
  }

  function addSubCategory(subcategory) {
    //console.log('CHECK : ', subcategory)
    dispatch({
      type: 'ADD_SUBCATEGORY',
      payload: subcategory,
    })
  }

  function editSubCategory(subcategory) {
    dispatch({
      type: 'EDIT_SUBCATEGORY',
      payload: subcategory,
    })
  }

  function removeSubCategory(id) {
    dispatch({
      type: 'REMOVE_SUBCATEGORY',
      payload: id,
    })
  }

  return (
    <SubCategoryContext.Provider
      value={{
        getNewSubCategories: getAllSubCategories,
        subcategories: state.subcategories,
        addNewSubCategory: addSubCategory,
        editNewSubCategory: editSubCategory,
        deleteNewSubCategory: removeSubCategory,
      }}
    >
      {children}
    </SubCategoryContext.Provider>
  )
}
